import { graphql } from 'src/gql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query positionNotesById($id: Int!) {
    cat {
      position {
        byId(_id: $id) {
          _id
          notes
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type PositionNotesById = NonNullable<NonNullable<NonNullable<NonNullable<TData>['cat']>['position']>['byId']>

const usePositionNotesById = (id: number): PositionNotesById | undefined => {
  const { data } = useGraphQL(document, { id }, {
    enabled: typeof id === 'number'
  })
  const position = data?.cat?.position?.byId ?? undefined
  return position
}

export { usePositionNotesById, document as positionNotesByIdDocument }
